<template>
  <div>
    <div class="px-4 pb-2 pt-1">
    <!-- Informations & image -->
      <v-row>
        <div
          :class="show ? 'col-12' : 'col-12' "
        >
          <v-card elevation="0" style="height: 100%;">
            <v-card-title style="cursor: pointer;" @click="toggleCard" class="d-flex justify-space-between align-center">
              <div>
                <v-icon class="mr-2">
                  {{show ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}}
                </v-icon>
                {{ $t('_informations_') }}
              </div>
            </v-card-title>

            <hr v-show="show" />

            <v-card-text v-if="show">
              <v-row v-show="show">
                <v-col
                  v-for="information in informations"
                  :key="information.index"
                  :class="information.index == 'address' ? 'col-3' : ''"
                >
                  <div>
                    {{ information.text }}
                  </div>
                  <div class="dark--text">
                    <span>{{ installation[information.index] }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recommendation: {
      type: String,
      required: false
    }
  },
    data(){
    return {
      informations: [
        {
          index: "build_date",
          text: this.$t('_mise_en_service_'),
        },
        {
          index: "address",
          text: this.$t('_adresse_'),
        },
        {
          index: "installation_type",
          text: this.$t('_type_d_installation_inclinaison_orientation_'),
        },
        {
          index: "company_name",
          text: this.$t('_groupe_'),
        },
        {
          index: "installed_power_kwc",
          text: this.$t('_puissance_crete_(kwc)_'),
        },
      ],
      show: false
    }
  },

  computed: {
    installation() {
      return this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      );
    },
  },

  methods: {
    toggleCard() {
      this.show = !this.show
    }
  }
}
</script>

<style lang="scss">
    
hr {
  margin: 0 14px;
  border: 0;
  border-top: 1px solid lightgray;
}
    
</style>